var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82129 3.85711C4.82129 2.50004 5.9285 1.39282 7.28557 1.39282H16.7141C18.0712 1.39282 19.1784 2.50004 19.1784 3.85711V20.9057C19.1784 21.4876 18.9911 22.1741 18.36 22.4785C17.7287 22.783 17.0749 22.502 16.6197 22.1395L12.8414 19.1322C12.8412 19.1321 12.8416 19.1324 12.8414 19.1322C12.3734 18.7621 11.558 18.7664 11.0994 19.1365L7.37843 22.1287C6.92675 22.4911 6.27327 22.7796 5.64005 22.477C5.00591 22.174 4.82129 21.4844 4.82129 20.9057V3.85711ZM7.28557 2.89282C6.75693 2.89282 6.32129 3.32846 6.32129 3.85711V20.9057C6.32129 20.9572 6.324 21.0015 6.32826 21.0389C6.36062 21.0186 6.39746 20.9926 6.43843 20.9598M6.43843 20.9598L10.1574 17.9692C10.1576 17.9691 10.1572 17.9693 10.1574 17.9692C11.1644 17.1569 12.7578 17.1527 13.7726 17.9563L13.7741 17.9574L17.5541 20.966C17.5983 21.0013 17.6373 21.0281 17.6703 21.0482C17.6751 21.0098 17.6784 20.9626 17.6784 20.9057V3.85711C17.6784 3.32846 17.2428 2.89282 16.7141 2.89282H7.28557",
    fill: "#265EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39258 11.5714C7.39258 11.1572 7.72836 10.8214 8.14258 10.8214H15.8569C16.2711 10.8214 16.6069 11.1572 16.6069 11.5714C16.6069 11.9856 16.2711 12.3214 15.8569 12.3214H8.14258C7.72836 12.3214 7.39258 11.9856 7.39258 11.5714Z",
    fill: "#67C2E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39258 13.2856C7.39258 12.8714 7.72836 12.5356 8.14258 12.5356H15.8569C16.2711 12.5356 16.6069 12.8714 16.6069 13.2856C16.6069 13.6999 16.2711 14.0356 15.8569 14.0356H8.14258C7.72836 14.0356 7.39258 13.6999 7.39258 13.2856Z",
    fill: "#67C2E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.39258 15C7.39258 14.5858 7.72836 14.25 8.14258 14.25H15.8569C16.2711 14.25 16.6069 14.5858 16.6069 15C16.6069 15.4142 16.2711 15.75 15.8569 15.75H8.14258C7.72836 15.75 7.39258 15.4142 7.39258 15Z",
    fill: "#67C2E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 5.46423C11.2305 5.46423 10.6069 6.08784 10.6069 6.85709C10.6069 7.62634 11.2305 8.24995 11.9998 8.24995C12.769 8.24995 13.3926 7.62634 13.3926 6.85709C13.3926 6.08784 12.769 5.46423 11.9998 5.46423ZM9.10693 6.85709C9.10693 5.25941 10.4021 3.96423 11.9998 3.96423C13.5975 3.96423 14.8926 5.25941 14.8926 6.85709C14.8926 8.45477 13.5975 9.74995 11.9998 9.74995C10.4021 9.74995 9.10693 8.45477 9.10693 6.85709Z",
    fill: "#67C2E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/Bookmark.b790c5c595a57fe20bc7e3a69aa749c1.svg";
export { ForwardRef as ReactComponent };